import { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';

// Components.
import { InstructorApproverDetails } from '../../components/InstructorApproverDetails';
import { InstructorApproverAddHeader } from './InstructorApproverAddHeader';

// Hooks.
import { useAccount } from 'hooks';

// Layouts.
import { ContentLayout } from 'layouts';
import { IInstructorApprover } from '@comptia-sso/core';

export const InstructorApproverAddView = (): ReactElement => {
  const [account] = useAccount();
  const [searchParams] = useSearchParams();
  const institutionId = searchParams.get('institutionId') || '';

  const instructorApprover = {
    isActive: true,
    email: '',
    firstName: '',
    lastName: '',
    institutionId,
  } as unknown as IInstructorApprover;

  return (
    <>
      <ContentLayout
        header={<InstructorApproverAddHeader />}
        content={
          <InstructorApproverDetails
            account={account}
            mode="add"
            instructorApprover={instructorApprover}
            defaultInstitutionId={institutionId}
          />
        }
      />
    </>
  );
};
